<!--
  Angular template reference for rendering the pagination item.

  Context:
    {
      id: string
      page: number
      content: string
      disabled?: boolean
      active?: boolean
    }
-->
<ng-template
  #pageItem
  let-disabled="disabled"
  let-active="active"
  let-page="page"
  let-content="content">
  <li
    #paginationItem="gpeiPaginationItem"
    gpeiPaginationItem
    [disabled]="disabled ?? false"
    [active]="active ?? false"
    [page]="page"
    [pageSize]="pageSize"
    (pageSelected)="onPageSelected($event)">
    <a class="page-link" role="button" [tabindex]="paginationItem.disabled ? -1 : 0">
      {{ content }}
    </a>
  </li>
</ng-template>

<!-- Render out the pagination element using template outlets for the pagination items -->
<ul class="pagination">
  <ng-container *ngIf="directionalButtons">
    <ng-container *ngTemplateOutlet="pageItem;
      context: {
        disabled: page === 1,
        page: 1,
        content: 'First'
      }">
    </ng-container>

    <ng-container *ngTemplateOutlet="pageItem;
      context: {
        disabled: page === 1,
        page: page - 1,
        content: 'Previous'
      }">
    </ng-container>
  </ng-container>

  <ng-container *ngFor="let pageNumber of pages">
    <ng-container *ngIf="withinMaxRange(pageNumber)">
      <ng-container *ngTemplateOutlet="pageItem;
        context: {
          active: pageNumber === page,
          page: pageNumber,
          content: pageNumber
        }">
      </ng-container>
    </ng-container>
  </ng-container>

  <ng-container *ngIf="directionalButtons">
    <ng-container *ngTemplateOutlet="pageItem;
      context: {
        disabled: page === totalPages,
        page: page + 1,
        content: 'Next'
      }">
    </ng-container>

    <ng-container *ngTemplateOutlet="pageItem;
      context: {
        disabled: page === totalPages,
        page: totalPages,
        content: 'Last'
      }">
    </ng-container>
  </ng-container>
</ul>
